module.exports = __webpack_public_path__ + "static/herbaColection-beae8d4465be0a7d90b9c8e6b9f7fe24.png";